<template>
  <v-dialog v-model="show">
    <v-card>
      <v-card-title class="d-flex" style="position: relative"
                    :class="$vuetify.breakpoint.smAndDown ? 'justify-start' : 'justify-center'">
        <h2>Address Locator</h2>
        <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

            <v-divider color="#42a5f5"></v-divider>
            <v-container py-0>
              <v-row justify="center">
                <v-col cols="12" md="12">
                    <!-- Google Maps Autocomplete with Clear Button -->
                    <div class="search-container">
                  <GmapAutocomplete
                    ref="autocomplete"
                    :options="autocompleteOptions"
                    :key="autocompleteKey"
                    @place_changed = "handlePlaceChanged"
                    class="googleSearchBar"
                    placeholder = "Search Google Maps"
                  ></GmapAutocomplete>
                      <v-btn icon @click="clearSearch" class="clear-btn">
                        ❌
                      </v-btn>
                    </div>
                </v-col>
              </v-row>

              <v-row justify="center" class="searchButton">
                  <v-btn @click="searchLocation">Search</v-btn>
              </v-row>
            </v-container>

      <v-divider></v-divider>
      <v-container py-0>
        <v-row>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="6" md="6" >
                <v-text-field
                  label="Name"
                  v-model="delivery.name"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="6" md="6">
                <v-text-field
                  v-model="delivery.phone1"
                  label="Phone"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="location.street1"
                  label="Street1"
                  :disabled="!manualPermission"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="location.street2"
                  label="Street2"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="location.suburb"
                  label="Suburb"
                  :disabled="!manualPermission"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="location.state"
                  label="State"
                  :items="selectedStates"
                  :disabled="!manualPermission"
                ></v-select>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="location.postcode"
                  label="Postcode"
                  :disabled="!manualPermission"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="10" md="5">
                <v-select
                  v-model="location.country"
                  label="Country"
                  :items="countries"
                  :disabled="!manualPermission"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="location.latitude"
                  label="Latitude"
                  :disabled="!manualPermission"
                  @input="parseLat"
                  @paste="pasteCoord"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="location.longitude"
                  label="Longitude"
                  :disabled="!manualPermission"
                  @input="parseLng"
                  @paste="pasteCoord"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" v-if="manualPermission">
                <v-text-field
                  v-model="quickSet"
                  label="Quick Set"
                  @paste="pasteCoord"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="location.instructions"
                  label="Delivery Instructions"
                  rows="2"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <GmapMap
              :center="center"
              :zoom="zoom"
              map-type-id="terrain"
              style="height: 500px; width: 100%"
              @ready="onMapReady"
            >
              <GmapMarker
                v-if="marker !== null"
                :position="marker"
                :clickable="true"
                :draggable="true"
                @dragend="updateCoordinates"
                @click="center=marker"
              />
            </GmapMap>
          </v-col>
        </v-row>

      </v-container>

      <v-card-actions class="justify-center">
        <v-btn text color="blue-grey lighten-2" @click="$emit('close')">Cancel</v-btn>
        <v-btn text color="indigo" @click="done">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "GeocodeDialog",
        components: {},
        props: {
            tracking: String,
            showProp: Boolean,
            value: {
                type: Object,
            },
            delivery: {
              type: Object,
              default: null
            },
        },
        data() {
            return {
                search: null,
                loading: false,
                marker: null,
                searchGeocode: null,
                center: {lat: -25.2743988, lng: 133.7751312},
                zoom: 3,
                quickSet: null,
                location: {
                    street1: null,
                    street2: null,
                    suburb: null,
                    state: null,
                    postcode: null,
                    latitude: null,
                    longitude: null,
                    instructions: null,
                    phone1:null,
                    name:null,
                    country:"Australia"
                },
                states: [
                    "ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"
                ],
                states_nz: [
                  "Auckland",
                  "Wellington",
                  "Canterbury",
                  "Bay of Plenty",
                  "Gisborne",
                  "Hawke's Bay",
                  "Manawatu-Wanganui",
                  "Marlborough",
                  "Nelson",
                  "Northland",
                  "Otago",
                  "Southland",
                  "Taranaki",
                  "Tasman",
                  "West Coast"
                ],
                countries:[
                   "Australia",
                   "New Zealand"
                ],
                autocompleteKey: 0,
                place: null,
                allowedCountries: ["AU", "NZ"],
                autocomplete: null,
                formattedAddress: "",
                autocompleteOptions: {
                  componentRestrictions: { country: ["AU", "NZ"] }, // Restrict autocomplete to Australia and New Zealand
                  fields: ["address_components", "formatted_address", "geometry"],
                  types: ["address"], // Restrict to addresses only
                },
            }
        },
        computed: {
            show: {
                get() {
                    return this.showProp;
                },
                set(value) {
                    if (!value) {
                        this.clear();
                        this.$emit('close');
                    }
                }
            },
            manualPermission() {
                return this.$store.getters['auth/isInternalUser'];
            },
            selectedStates() {
              return this.location.country === "New Zealand" ? this.states_nz : this.states;
            }
        },
        mounted() {
          this.$nextTick(() => {
            this.applyCustomStyles();
          });
        },
        methods: {
            applyCustomStyles() {
              const style = document.createElement('style');
              style.innerHTML = `
                .pac-container {
                  font-size: 30px !important; /* Make text bigger */
                  width: 1500px;
                }
                .pac-item {
                  font-size: 28px !important; /* Ensure each item in the list has larger font size */
                }
                .pac-item:hover {
                  background-color: #f0f0f0 !important; /* Hover effect */
                }
                .pac-item-selected {
                  background-color: #dcdcdc !important; /* Selected item effect */
                }
                .pac-item-query {
                  font-size:28px;
                }
              `;
              document.head.appendChild(style);
            },
            handlePlaceChanged() {
              const place = this.$refs.autocomplete.$autocomplete.getPlace(); // Fetch place object

              if (!place || !place.geometry) {
                alert("Invalid address, please try again.");
                return;
              }
               this.place = place;

              // Auto-populate fields immediately when a place is selected
              this.searchLocation();

              if (this.place !== null  ) {
                console.log("Place Information:", this.place);
              } else {
                console.log("Invalid place object");
              }
            },
            searchLocation() {
              if (this.place && this.place.geometry) {
                this.center = {
                  lat: this.place.geometry.location.lat(),
                  lng: this.place.geometry.location.lng(),
                };
                this.zoom = 16;
                this.marker = this.center; // Place the marker at the selected location
                // Extract address components
                const addressComponents = this.place.address_components;

                // Populate street1 from address components (include subpremise e.g. unit number)
                const subpremise = this.getAddressComponent(addressComponents, "subpremise");
                this.location.street1 = (subpremise ? subpremise + ', ' : '') +
                  this.getAddressComponent(addressComponents, "street_number") +
                  ' ' + this.getAddressComponent(addressComponents, "route");

                this.location.suburb =  this.getAddressComponent(addressComponents, "locality");
                if(this.getAddressComponent(addressComponents, "country") === 'Australia'){
                  this.location.state = this.parseState(this.getAddressComponent(addressComponents, "administrative_area_level_1"));
                } else this.location.state = this.getAddressComponent(addressComponents, "administrative_area_level_1");
                this.location.postcode = this.getAddressComponent(addressComponents, "postal_code");
                this.location.country =  this.getAddressComponent(addressComponents, "country");
                this.location.latitude = this.place.geometry.location.lat();
               this.location.longitude = this.place.geometry.location.lng();
                console.log("Extracted Address:", this.location);

              }
            },

          parseState(stateName){
            const stateMapping = {
              "New South Wales": "NSW",
              "Victoria": "VIC",
              "Queensland": "QLD",
              "Western Australia": "WA",
              "South Australia": "SA",
              "Tasmania": "TAS",
              "Australian Capital Territory": "ACT",
              "Northern Territory": "NT",
            };
            return stateMapping[stateName] || stateName;

          },
          getAddressComponent(components, type) {
            const component = components.find((comp) => comp.types.includes(type));
            return component ? component.long_name : "";
          },
          onMapReady(map) {
            console.log("Google Map is ready:", map);
          },
          done() {
              this.location.phone1 = this.delivery.phone1;
              this.location.name = this.delivery.name;
              this.$emit('done', this.location);
          },
          distance(lat1, lon1, lat2, lon2, unit) {
              if ((lat1 === lat2) && (lon1 === lon2)) {
                  return 0;
              } else {
                  var radlat1 = Math.PI * lat1 / 180;
                  var radlat2 = Math.PI * lat2 / 180;
                  var theta = lon1 - lon2;
                  var radtheta = Math.PI * theta / 180;
                  var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                  if (dist > 1) {
                      dist = 1;
                  }
                  dist = Math.acos(dist);
                  dist = dist * 180 / Math.PI;
                  dist = dist * 60 * 1.1515;
                  if (unit === "K") {
                      dist = dist * 1.609344
                  }
                  if (unit === "N") {
                      dist = dist * 0.8684
                  }
                  return dist;
              }
          },
          updateCoordinates(location) {
            this.center = this.marker;
          },
          clearSearch(){
            const instructions = this.location.instructions;
            this.search = null;
            this.marker = null;
            this.searchGeocode = null;
            for (let key of Object.keys(this.location)) {
              this.location[key] = null;
            }
            this.location.instructions = instructions;
            this.center = {lat: -25.2743988, lng: 133.7751312};
            this.zoom = 3;
            this.autocompleteKey++;
          },
          parseLat() {
              let lat = parseFloat(this.location.latitude);
              if (!isNaN(lat)) {
                  if (this.marker !== null) {
                      this.marker.lat = lat;
                  } else {
                      let lng = parseFloat(this.location.longitude);
                      if (!isNaN(lng)) {
                          this.initMarker(lat, lng);
                      }
                  }
              } else {
                  this.$store.commit('displaySnackbar', 'Invalid latitude');
              }
          },
          parseLng() {
              let lng = parseFloat(this.location.longitude);
              if (!isNaN(lng)) {
                  if (this.marker !== null) {
                      this.marker.lng = lng;
                  } else {
                      let lat = parseFloat(this.location.latitude);
                      if (!isNaN(lat)) {
                          this.initMarker(lat, lng);
                      }
                  }
              } else {
                  this.$store.commit('displaySnackbar', 'Invalid longitude');
              }
          },
          pasteCoord(evt) {
              let val = evt.clipboardData.getData('Text').split(',');
              let lat = parseFloat(val[0].trim());
              let lng = parseFloat(val[1].trim());
              if (!isNaN(lat) && !isNaN(lng)) {
                  this.location.latitude = lat;
                  this.location.longitude = lng;
                  this.initMarker(lat, lng);
              } else {
                  this.$store.commit('displaySnackbar', 'Invalid coordinates');
              }
              this.quickSet = null;
          },
          initMarker(lat, lng) {
              this.marker = {lat, lng};
              this.zoom = 16;
              this.center = this.marker;
          },
          clear() {
              const instructions = this.location.instructions;
              this.search = null;
              this.marker = null;
              this.searchGeocode = null;
              for (let key of Object.keys(this.location)) {
                  this.location[key] = null;
              }
              this.location.instructions = instructions;
              this.center = {lat: -25.2743988, lng: 133.7751312};
              this.zoom = 3;
          },
            searchAddress() {
                if (this.search !== null) {
                    this.loading = true;
                    axios.get(process.env.API_URL + '/addressify?action=info&term=' + this.search.replace(' ', '+'))
                        .then((response) => {
                            if (response.status === 200) {
                                this.location.street1 = response.data.StreetLine;
                                this.location.suburb = response.data.Suburb;
                                this.location.state = response.data.State;
                                this.location.postcode = response.data.Postcode;
                                this.location.latitude = response.data.Latitude;
                                this.location.longitude = response.data.Longitude;
                                this.initMarker(this.location.latitude, this.location.longitude);
                                this.searchGeocode = this.marker;
                                this.info =  response.data;
                                this.loading = false;
                            }
                        })
                        .catch(() => {
                            this.$store.commit('displaySnackbar', 'An error occurred');
                            this.loading = false;
                        })
                }
            },
        },
        watch: {
            search() {
                if (this.search === null) {
                    this.clear();
                }
            },
            value(val) {
                if (val === null) {
                    this.clear();
                } else {
                    this.location = val;
                }
            },
            showProp(isOpen, wasOpen) {
              if (isOpen && !wasOpen) {
                this.clearSearch();
              }
            }
        }
    }
</script>

<style scoped>

.googleSearchBar{
  margin-top: 20px;
  margin-left: 0;
  width:1500px;
  flex: 2;
  border: none;
  outline: none;
  font-size: 30px;
  padding: 10px;
  background: transparent; /* Transparent input field */

}

.searchButton{
  margin-top: 30px;
  margin-bottom: 30px;
}

.search-container {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #ccc; /* Underline effect */
  padding: 5px;
  width: 100%;

}

/* Scoped styles using ::v-deep to target Google Maps Autocomplete's styles */
::v-deep .pac-container {
  font-size: 28px !important;  /* Increase font size */
  width: 1500px;
}

::v-deep .pac-item {
  font-size: 28px !important;  /* Set font size for each item */
}

::v-deep .pac-item-query {
  font-size:28px;
}

::v-deep .pac-item:hover {
  background-color: #f0f0f0 !important;  /* Hover effect */
}

::v-deep .pac-item-selected {
  background-color: #dcdcdc !important;  /* Selected item effect */
}

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/GeocodeDialog.vue